import { useEffect } from "react";
import LoginForm from "../components/Controls/LoginForm";
import { useModalExit } from "../components/Controls/useModalExit";
import { ModalBusyProvider, ModalBusyOverlay, useModalBusy } from "../components/Controls/modalBusy";

function LoginModalChrome({ updateLogin, onSwitchToRegister, requestClose, exiting }) {
  const { busy } = useModalBusy();
  const safeClose = () => {
    if (busy) return;
    requestClose();
  };

  useEffect(() => {
    if (exiting) return undefined;
    function onKeyDown(e) {
      if (e.key === "Escape") safeClose();
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [exiting, busy, requestClose]);

  return (
    <div
      className={`mkt-login-overlay${exiting ? " is-exiting" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-busy={busy}
      aria-labelledby="mkt-login-title"
    >
      <button
        type="button"
        className="mkt-login-backdrop"
        aria-label="Close login"
        onClick={safeClose}
        disabled={busy}
      />
      <div className={`mkt-login-dialog${busy ? " is-busy" : ""}`}>
        <div className="mkt-login-dialog__header">
          <h2 id="mkt-login-title">Log In</h2>
          <button
            type="button"
            className="mkt-login-dialog__close"
            aria-label="Close"
            onClick={safeClose}
            disabled={busy}
          >
            ×
          </button>
        </div>
        <div className="mkt-login-dialog__body">
          <LoginForm
            embedded
            updateLogin={updateLogin}
            onClose={requestClose}
            onSwitchToRegister={onSwitchToRegister}
          />
        </div>
        <ModalBusyOverlay />
      </div>
    </div>
  );
}

export default function LoginModal({ updateLogin, onClose, onSwitchToRegister }) {
  const { rendered, exiting, requestClose } = useModalExit({ open: true, onClose });
  if (!rendered) return null;
  return (
    <ModalBusyProvider>
      <LoginModalChrome
        updateLogin={updateLogin}
        onSwitchToRegister={onSwitchToRegister}
        requestClose={requestClose}
        exiting={exiting}
      />
    </ModalBusyProvider>
  );
}
